import React from "react";
import { CheckIcon } from "lucide-react";
import { volumes } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function Volumes() {
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-282" data-mp="2x19v2fagicak">
      <div className="mx-auto max-w-5xl" data-id="element-283" data-mp="2wzyv6qk4tooq">
        <h2 className="text-center font-serif text-[2rem] font-extrabold leading-tight text-navy sm:text-5xl" data-id="element-284" data-mp="2szoo1aklss8a">
          What’s inside the <span className="italic text-teal" data-id="element-285" data-mp="2o0v7tadxmn4f">Rhinoplasty Master Planner™?</span>
        </h2>

        <ol className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-286" data-mp="2j9d6gl7zykix">
          {volumes.map(v => <li key={v.number} className="flex flex-col overflow-hidden rounded-3xl bg-white shadow-[0_10px_30px_-18px_rgba(11,27,46,0.35)]" data-id="element-287" data-mp="2ea8ytz0q0uup">
              <div className="flex items-center gap-4 bg-navy px-5 py-5" data-id="element-288" data-mp="29da7tpcct40q">
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-teal-light font-serif text-xl font-extrabold text-navy" data-id="element-289" data-mp="2592etfyv51wp">
                  {v.number}
                </span>
                <div data-id="element-290" data-mp="334ui3wxvyhur">
                  <p className="text-xs font-bold uppercase tracking-[0.16em] text-teal-light" data-id="element-291" data-mp="334bd1gtc3ny5">Volume {v.number}</p>
                  <h3 className="mt-0.5 font-serif text-xl font-extrabold leading-snug text-white" data-id="element-292" data-mp="37y76c5ynkmmz">{v.title}</h3>
                </div>
              </div>
              <div className="flex flex-1 flex-col p-5 sm:p-6" data-id="element-293" data-mp="2y7kummu24g9k">
                <p className="text-base leading-relaxed text-ink-muted" data-id="element-294" data-mp="3lwdjjzc9hnuo">{v.description}</p>
                <p className="mt-5 text-sm font-bold text-navy" data-id="element-295" data-mp="3qv8bprw4corg">Inside:</p>
                <ul className="mt-3 grid gap-2" data-id="element-296" data-mp="3qufbzavkuzit">
                  {v.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] leading-snug text-ink" data-id="element-297" data-mp="3cv5zomahspk4">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-298" data-mp="3hwmwo6puvrvf" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </li>)}
        </ol>

        <CtaButton label="I want all 6 volumes today" className="mt-10" data-id="element-299" data-mp="bxtvsmjc3909" />
      </div>
    </section>;
}